export interface DistributionCenterProps {
  dcId: number;
  dcCode: string;
  dcName: string;
  purchaserId: number;
  purchaserName: string;
}

export class DistributionCenter {
  private readonly _dcId: number;
  private readonly _dcCode: string;
  private readonly _dcName: string;
  private readonly _purchaserId: number;
  private readonly _purchaserName: string;

  constructor(props: DistributionCenterProps) {
    this._dcId = props.dcId;
    this._dcCode = props.dcCode;
    this._dcName = props.dcName;
    this._purchaserId = props.purchaserId;
    this._purchaserName = props.purchaserName;
  }

  public get dcId(): number {
    return this._dcId;
  }

  public get dcCode(): string {
    return this._dcCode;
  }

  public get dcName(): string {
    return this._dcName;
  }

  public get purchaserId(): number {
    return this._purchaserId;
  }

  public get purchaserName(): string {
    return this._purchaserName;
  }
}
